// Чистая логика раздела «Реестры» (без Vue) — покрыта tests/unit/registryLogic.test.mjs.

export const FLEETS = [
  { value: 'hired', label: 'Наёмный' },
  { value: 'own', label: 'Собственный' },
]

export const DAY_KINDS = [
  { value: 'calendar', label: 'календарных' },
  { value: 'bank', label: 'рабочих' },
]

export const CHECK_LABELS = {
  ok: 'Сверено',
  mismatch: 'Расхождение',
  incomplete: 'Нет данных',
}

export const SOURCE_LABELS = { erp: 'ERP', tms_efes: 'TMS', transmanager: 'ТМ' }

export function formatDate(value) {
  if (!value) return '—'
  const [y, m, d] = String(value).slice(0, 10).split('-')
  return d && m && y ? `${d}.${m}.${y}` : String(value)
}

export function formatMoney(value) {
  if (value === null || value === undefined || value === '') return '—'
  const number = Number(value)
  if (!Number.isFinite(number)) return String(value)
  return number.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function sumSelected(trips, selectedIds) {
  const selected = new Set(selectedIds)
  let total = 0
  let count = 0
  for (const trip of trips || []) {
    if (!selected.has(trip.id)) continue
    count += 1
    total += Number(trip.price || 0)
  }
  return { count, total: Math.round(total * 100) / 100 }
}

export function rowTone(flags) {
  const levels = (flags || []).map((f) => f.level)
  if (levels.includes('critical')) return 'critical'
  if (levels.includes('warning')) return 'warning'
  return 'ok'
}

export function daysLeft(dateValue, today = new Date()) {
  if (!dateValue) return null
  const [y, m, d] = String(dateValue).slice(0, 10).split('-').map(Number)
  const target = Date.UTC(y, m - 1, d)
  const base = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
  return Math.round((target - base) / 86400000)
}

export function termsText(t) {
  if (!t) return ''
  const kind = (k) => (k === 'bank' ? 'раб.' : 'к.')
  const rule = t.payment_rule ? paymentRuleText(t.payment_rule) : ''
  return [
    `отправка комплекта ${t.send_docs_days} ${kind(t.send_docs_kind)} дн.`,
    `проверка ${t.review_days} ${kind(t.review_kind)} дн.`,
    `подписание с/ф ${t.signing_days} ${kind(t.signing_kind)} дн.`,
    `оригиналы ≤ ${t.originals_days} ${kind(t.originals_kind)} дн.`,
    `оплата ${t.payment_days} ${kind(t.payment_kind)} дн.${rule ? ', ' + rule : ''}`,
  ].join(' · ')
}

const WEEKDAYS = ['понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота', 'воскресенье']

export function paymentRuleText(rule) {
  if (!rule) return ''
  const nth = Array.isArray(rule.nth) ? rule.nth : [rule.nth || 1]
  return `${nth.join('-й и ')}-й ${WEEKDAYS[rule.weekday ?? 1] || ''} месяца`
}

export function filterTrips(trips, query) {
  const q = String(query || '').trim().toLowerCase()
  if (!q) return trips || []
  return (trips || []).filter((t) =>
    [t.number, t.route, t.carrier_name, t.finance_status].some((v) => String(v || '').toLowerCase().includes(q)))
}

export function emptyTerms(customerId) {
  return {
    customer_id: customerId,
    contract_name: '',
    effective_from: '',
    send_docs_days: 17, send_docs_kind: 'calendar',
    review_days: 8, review_kind: 'calendar',
    signing_days: 2, signing_kind: 'bank',
    originals_days: 30, originals_kind: 'calendar',
    payment_days: 75, payment_kind: 'calendar',
    payment_rule: { nth: [1], weekday: 1 },
    price_tolerance: '1.00',
    required_sources: ['tms_efes', 'transmanager'],
    comment: '',
  }
}
